import { LoadScript } from "@react-google-maps/api";

export const libraries = ["places"];

export const GoogleMapsProvider = ({ children }) => {
  return (
    <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY} libraries={libraries}>
        {children}
    </LoadScript>
  )
}

export const IconUrl = "/icons/marker.png";

export const containerStyle = {
    width: "100%",
    height: "100%",
};